import { Injectable, inject } from '@angular/core';
import { IncentivePartnerAchievementFilterOptions } from '@coin/shared/core/util-enums';
import {
  IncentivePartnerService,
  IncentivePartnerServiceQueryFieldValuesMonitoringRequestParams
} from '@coin/shared/core/data-access';
import { TinyHelpers } from '@coin/shared/core/util-helpers';
import { ToastrService } from 'ngx-toastr';
import { IncentiveSupportComponentState } from './incentive-support.component.state';

@Injectable()
export class AchievementFieldValuesService {
  private incentiveSupportComponentState = inject(IncentiveSupportComponentState);
  private achievementService = inject(IncentivePartnerService);
  private toast = inject(ToastrService);

  public getFieldValues(
    page: number,
    size: number,
    targetProperty: IncentivePartnerAchievementFilterOptions,
    searchText?: string
  ) {
    const selectedSeason = this.incentiveSupportComponentState.getSelectedSeason();
    if (!selectedSeason) {
      throw new Error('Cannot get field values without selected season');
    }

    const args: IncentivePartnerServiceQueryFieldValuesMonitoringRequestParams = {
      seasonId: selectedSeason.id,
      page: page + 1,
      size,
      targetProperty: this.mappedTargetPropertyToIndex(targetProperty)
    };
    const camelCaseTargetProperty = TinyHelpers.pascalcaseToCamelCase(targetProperty);
    args[`${camelCaseTargetProperty}`] = searchText;

    return this.achievementService.queryFieldValuesMonitoring(args);
  }

  private mappedTargetPropertyToIndex(targetProperty: IncentivePartnerAchievementFilterOptions) {
    // TODO: Transform to enum in swagger for easier mapping?
    switch (targetProperty) {
      case IncentivePartnerAchievementFilterOptions.Are:
        return 4;
      case IncentivePartnerAchievementFilterOptions.Country:
        return 5;
      case IncentivePartnerAchievementFilterOptions.PlanName:
        return 7;
      case IncentivePartnerAchievementFilterOptions.Template:
        return 8;
      case IncentivePartnerAchievementFilterOptions.ProcessStates:
        return 12;
      case IncentivePartnerAchievementFilterOptions.PayoutState:
        return 13;
      case IncentivePartnerAchievementFilterOptions.PayrollStates:
        return 14;
      default:
        this.toast.error(`Target Property Mapping not implemented for ${targetProperty}`);
        throw new Error();
    }
  }
}
